const mobileMenu = function() {
  const btnOpen = ".js-menu-btn";
  const btnClose = ".js-menu-close-btn";
  const leftColumn = ".js-left-column";
  const mainContent = ".js-main-content";
  const menuCover = ".js-menu-cover";
  const openLeftColumnClass = "layout__left-column--show";
  const slideContentClass = "layout__content--slide-right";
  const menuCoverShowClass = "layout__cover--show";

  $body.on("click", btnOpen, function() {
    $(leftColumn).addClass(openLeftColumnClass);
    $(mainContent).addClass(slideContentClass);
    $(menuCover).addClass(menuCoverShowClass);
    isMenuOpen = true;
  });

  $body.on("click", `${btnClose}, ${menuCover}`, function() {
    $(leftColumn).removeClass(openLeftColumnClass);
    $(mainContent).removeClass(slideContentClass);
    $(menuCover).removeClass(menuCoverShowClass);
    isMenuOpen = false;
  });
};

module.exports = mobileMenu();
